export const PATHS = 'paths'
export const COMPONENTS = 'components'
export const PAGES = 'pages'
export const ATOMS = 'atoms'
